export const companyEngagementsSummary = action => {
  return {
    text: action.text || 'Summarize all engagements for the company',
    data: {
      intent: 'object_associations',
      chronological_association_type: 'COMPANY_TO_ENGAGEMENT',
      object: {
        object_type: 'COMPANY',
        object_search: {
          hs_object_id: action.companyId
        }
      }
    }
  };
};